import Product from "../../../../../../@types/Product";


const SeatFrames: Product[] = [
    {
        id: 1,
        name: 'G250 Kit',
        sku: '01-049-X6',
        price: 0.00,
        retailPrice: 0.00,
    },
];

export default SeatFrames;